export default "__VITE_ASSET__Dv$vg4rg__"